"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LabsAdapter = void 0;
const domain_1 = require("@home-health-notify/domain");
const Urls_1 = require("../Urls");
class LabsAdapter {
    constructor(httpAdapter, config) {
        this.httpAdapter = httpAdapter;
        this.config = config;
    }
    requestLab(data) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            try {
                const response = yield this.httpAdapter.post(this.config.baseUrl + Urls_1.urls.requestLab, data);
                return response.data.data;
            }
            catch (e) {
                throw (_a = domain_1.ApiError.fromAxiosError(e)) !== null && _a !== void 0 ? _a : e;
            }
        });
    }
    getLabs(context) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield this.httpAdapter.get(this.config.baseUrl + Urls_1.urls.getLabs, {
                    signal: context === null || context === void 0 ? void 0 : context.newAbortSignal(new AbortController()),
                });
                return (0, domain_1.CompletedResult)(response.data.data);
            }
            catch (e) {
                if (e instanceof Error && e.name === "CanceledError") {
                    return domain_1.AbortedResult;
                }
                throw e;
            }
        });
    }
    getLabDetails(labId, context) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield this.httpAdapter.get(this.config.baseUrl + Urls_1.urls.getLabDetails(labId), {
                    signal: context === null || context === void 0 ? void 0 : context.newAbortSignal(new AbortController()),
                });
                return (0, domain_1.CompletedResult)(response.data.data);
            }
            catch (e) {
                if (e instanceof Error && e.name === "CanceledError") {
                    return domain_1.AbortedResult;
                }
                throw e;
            }
        });
    }
    getLabRequisitions(groupId, context) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield this.httpAdapter.get(this.config.baseUrl + Urls_1.urls.getLabRequisitions(groupId), {
                    signal: context === null || context === void 0 ? void 0 : context.newAbortSignal(new AbortController()),
                });
                return (0, domain_1.CompletedResult)(response.data);
            }
            catch (e) {
                if (e instanceof Error && e.name === "CanceledError") {
                    return domain_1.AbortedResult;
                }
                throw e;
            }
        });
    }
    getAllLabRequisitions(params, context) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const queryParams = {
                    limit: params.limit,
                    cursor: params.cursor,
                };
                if (params.filters) {
                    queryParams.filters = JSON.stringify(params.filters);
                }
                if (params.search) {
                    queryParams.search = params.search;
                }
                const response = yield this.httpAdapter.get(this.config.baseUrl + Urls_1.urls.getAllLabRequisitions, {
                    params: queryParams,
                    signal: context === null || context === void 0 ? void 0 : context.newAbortSignal(new AbortController()),
                });
                return (0, domain_1.CompletedResult)(response.data);
            }
            catch (e) {
                if (e instanceof Error && e.name === "CanceledError") {
                    return domain_1.AbortedResult;
                }
                throw e;
            }
        });
    }
    getLabRequisitionOrders(requisitionId, context) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield this.httpAdapter.get(this.config.baseUrl + Urls_1.urls.getLabRequisitionOrders(requisitionId), {
                    signal: context === null || context === void 0 ? void 0 : context.newAbortSignal(new AbortController()),
                });
                return (0, domain_1.CompletedResult)(response.data);
            }
            catch (e) {
                if (e instanceof Error && e.name === "CanceledError") {
                    return domain_1.AbortedResult;
                }
                throw e;
            }
        });
    }
}
exports.LabsAdapter = LabsAdapter;
